(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRideezPopup = (root) => {
      if (!root || root.dataset.bound === 'true') return;

      root.dataset.bound = 'true';

      const dialog =
        root.querySelector('.rideez-cro-popup');

      const openButtons =
        root.querySelectorAll('[data-popup-open]');

      const closeButtons =
        root.querySelectorAll('[data-popup-close]');

      const reopenButton =
        root.querySelector('.rideez-cro-popup-tab');

      const signupForm =
        root.querySelector('.rideez-cro-popup__form');

      const submitButton =
        root.querySelector('[data-popup-submit]');

      const successMarker =
        root.querySelector('[data-popup-success-marker]');

      const copyButton =
        root.querySelector('[data-copy-code]');

      const codeInput =
        root.querySelector('[data-discount-code]');

      const shopButton =
        root.querySelector('[data-popup-shop]');

      if (!dialog) return;

      const mode = root.dataset.mode;

      const testMode =
        mode === 'testing' ||
        mode === 'success_testing';

      const delay =
        Math.max(
          Number(root.dataset.delaySeconds) || 5,
          0
        ) * 1000;

      const frequency =
        Math.max(
          Number(root.dataset.delayDays) || 7,
          1
        ) * 86400000;

      const storagePrefix =
        `rideez-start-popup-${window.location.host}`;

      const dismissKey =
        `${storagePrefix}-dismissed`;

      const subscribedKey =
        `${storagePrefix}-subscribed`;

      let viewed = false;

      const track = (eventName, detail = {}) => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: eventName,
          popup_name: 'rideez_start_10_off',
          ...detail
        });
      };

      const openDialog = (reason = 'manual') => {
        if (dialog.open) return;

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }

        reopenButton.hidden = true;

        if (!viewed) {
          viewed = true;

          track('rideez_popup_view', {
            open_reason: reason
          });
        }
      };

      const closeDialog = (reason = 'dismiss') => {
        if (
          dialog.open &&
          typeof dialog.close === 'function'
        ) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }

        if (!testMode && !successMarker) {
          localStorage.setItem(
            dismissKey,
            String(Date.now() + frequency)
          );
        }

        if (
          root.dataset.showReopen === 'true' &&
          !successMarker
        ) {
          reopenButton.hidden = false;
        }

        track('rideez_popup_close', {
          close_reason: reason
        });
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', () => {
          openDialog('reopen_tab');
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          closeDialog('button');
        });
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog('escape');
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeDialog('backdrop');
        }
      });

      if (signupForm && submitButton) {
        signupForm.addEventListener('submit', () => {
          submitButton.disabled = true;
          submitButton.setAttribute(
            'aria-busy',
            'true'
          );

          track('rideez_popup_submit');
        });
      }

      if (copyButton && codeInput) {
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(
              codeInput.value
            );
          } catch (error) {
            codeInput.removeAttribute('tabindex');
            codeInput.select();
            document.execCommand('copy');
            codeInput.setAttribute('tabindex', '-1');
          }

          copyButton.textContent =
            copyButton.dataset.copiedLabel;

          track('rideez_popup_code_copy');

          window.setTimeout(() => {
            copyButton.textContent =
              copyButton.dataset.defaultLabel;
          }, 2200);
        });
      }

      if (shopButton) {
        shopButton.addEventListener('click', () => {
          track('rideez_popup_shop_click');
        });
      }

      if (successMarker) {
        localStorage.setItem(
          subscribedKey,
          'true'
        );

        localStorage.removeItem(dismissKey);

        openDialog('signup_success');
        track('rideez_popup_success');

        return;
      }

      if (testMode) {
        openDialog('test_mode');
        return;
      }

      if (
        localStorage.getItem(subscribedKey) === 'true'
      ) {
        return;
      }

      const dismissedUntil =
        Number(
          localStorage.getItem(dismissKey) || 0
        );

      if (dismissedUntil > Date.now()) {
        if (root.dataset.showReopen === 'true') {
          reopenButton.hidden = false;
        }

        return;
      }

      let triggered = false;

      const triggerOnce = (reason) => {
        if (triggered) return;

        triggered = true;
        openDialog(reason);
      };

      window.setTimeout(() => {
        triggerOnce('delay');
      }, delay);

      const handleScroll = () => {
        const scrollable =
          document.documentElement.scrollHeight -
          window.innerHeight;

        if (
          scrollable > 0 &&
          window.scrollY / scrollable >= 0.35
        ) {
          triggerOnce('scroll_35');

          window.removeEventListener(
            'scroll',
            handleScroll
          );
        }
      };

      window.addEventListener(
        'scroll',
        handleScroll,
        { passive: true }
      );

      if (
        root.dataset.exitIntent === 'true' &&
        window.matchMedia('(pointer: fine)').matches
      ) {
        const handleExit = (event) => {
          if (event.clientY <= 8) {
            triggerOnce('exit_intent');

            document.removeEventListener(
              'mouseout',
              handleExit
            );
          }
        };

        document.addEventListener(
          'mouseout',
          handleExit
        );
      }
    };

    const initAllRideezPopups = (
      scope = document
    ) => {
      scope
        .querySelectorAll('[data-rideez-popup]')
        .forEach(initRideezPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initAllRideezPopups()
      );
    } else {
      initAllRideezPopups();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initAllRideezPopups(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
